import React, { memo, useState } from "react";
import SuccessIcon from "../../../styles/img/svg/SuccessIcon";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal } from "react-bootstrap";

import { hideAjaxSuccess } from "../../../_redux/_actions";
import { authConstants } from "../../../_redux/_constants";

const UiInlineSuccessMessage = memo((props) => {
    const actionDispatch = useDispatch();

    const { successMessage } = useSelector((state) => {
        return {
            successMessage: state.successMessage,
        };
    });

    const [show, setShow] = useState(true);
    const handleClose = () => setShow(false);

    const hideAlert = () => {
        actionDispatch(hideAjaxSuccess());
    };

    return (
        (successMessage.identity ==
            authConstants.FORGOT_PASSWORD_EMAIL_VERIIFICATION_COMPLETE ||
            successMessage.identity ==
                authConstants.FORGOT_PASSWORD_RESET_PASSWORD_COMPLETE ||
            successMessage.identity ==
                authConstants.PRE_REGISTRATION_ACTIVATE_COMPLETE) &&
        successMessage.show && (
            <div className="sb-auth-success-message">
                <SuccessIcon />
                <span>{successMessage.messages[0]}</span>
            </div>
        )
    );
});

export default UiInlineSuccessMessage;
